import React, { useCallback, useEffect, useState } from "react";
// Images
import avatar4 from "assets/images/users/avatar-4.png";

// icons
import { Truck, CreditCard, CircleDollarSign, Download } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { cancelOrder, getOrderById } from "helpers/backend_helper";
import { format } from "date-fns"; // Icons
import { OrderDetailResponse, OrderLine, OrderStatusType } from "types/OrderType";

//Logo
import { Common } from "helpers/common";
import DeleteModal from "Common/DeleteModal";
import { ToastContainer } from "react-toastify";
import Modal from "Common/Components/Modal";
import { OrderStatus } from "./OrderStatus";
import { getImageUrl, OrderStatusList } from "constants/constants";
import { INVOICE_URL } from "constants/settings";

const OrderDetail = () => {
  const { orderId } = useParams() || "";
  console.log("orderId", orderId);
  const [orderDetail, setOrderDetail] = useState<OrderDetailResponse>(
    {} as OrderDetailResponse
  );
  const [show, setShow] = useState<boolean>(false);
  const uiHelper = new Common();

  const commonHelper = new Common();
  const [cancelModal, setCancelModal] = useState<boolean>(false);
  const cancelToggle = () => setCancelModal(!cancelModal);

  const [eventData, setEventData] = useState<any>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isCancelable, setIsCancelable] = useState<boolean>(false);
  const [invoiceUrl, setInvoiceUrl] = useState<string>("");
  // Get Data
  useEffect(() => {
    onGetOrderDetail();
    document.body.classList.remove('overflow-hidden');
  }, []);

  const onGetOrderDetail = async () => {
    try {
      const response = await getOrderById(orderId || "");
      console.log("Order Data", response.data);
      setOrderDetail(response.data[0]);
      var invoiceUrl = INVOICE_URL || "";
      setInvoiceUrl(invoiceUrl + response.data[0].orderHeader.filePath);
      checkIfOrderIsCancelable(response.data[0].orderHeader.orderStatus);
    } catch (err) {
      console.log("Error", err);
    }
  };

  const onOrderStatusSave = (result: any) => {
    if (result) {
      if (result?.toggle) {
        toggle();
      }
      uiHelper.showSuccessMessage('Order status updated.');
      onGetOrderDetail();

    } else {
      uiHelper.showErrorMessage('Something went wrong. Please try again later.');
    }

  }

  const checkIfOrderIsCancelable = (status: string) => {
    console.log('checking status', status)
    // const orderStatus = OrderStatusList.filter((item: any) => item.title === orderDetail?.orderHeader.orderStatus)
    // console.log(orderStatus, orderDetail?.orderHeader.orderStatus)
    if (OrderStatusList.find((item: any) => item.title === status && item.isCancelable)) {
      setIsCancelable(true);
    } else {
      setIsCancelable(false);
    }
  }

  // Update Data
  const handleUpdateStatusClick = () => {
    setEventData({ ...orderDetail?.orderHeader });
    setIsEdit(true);
    setShow(true);
  };


  // 
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
    } else {
      setShow(true);
      setEventData("");

    }
  }, [show]);

  const handleCancelOrder = async () => {
    console.log("cancel", orderId);
    try {

      if (orderId) {
        const response = await cancelOrder(orderId || "");
        console.log("Order Data", response);
        setCancelModal(false);

        commonHelper.showErrorMessage(
          `The order number ${orderDetail.orderHeader.orderNo} has been cancelled successfully.`,
        );
        await onGetOrderDetail();
      }
    } catch (err: any) {
      console.log('Error', err.response)

    }
  }


  return (
    <React.Fragment>
      {/* <BreadCrumb title="Order Overview" pageTitle="Ecommerce" /> */}
      <br />
      <ToastContainer closeButton={false} limit={1} />

      <DeleteModal
        show={cancelModal}
        onHide={cancelToggle}
        onDelete={handleCancelOrder}
        message="Are you sure you want to cancel this order?"
        buttonCaption="Yes, Cancel this Order!"
      />
      <div className="grid grid-cols-1 2xl:grid-cols-12   md:grid-cols-12  gap-x-5">
        <div className="2xl:col-span-3 md:col-span-3">
          <div className="card">
            <div className="card-body">
              <div className="flex items-center justify-center size-12 bg-purple-100 rounded-md dark:bg-purple-500/20 ltr:float-right rtl:float-left">
                <Truck className="text-purple-500 fill-purple-200 dark:fill-purple-500/30" />
              </div>
              <h6 className="mb-4 text-15">Shipping Details</h6>
              <h6 className="mb-1">
                {orderDetail?.shippingAddress?.name || orderDetail?.orderUser?.userName}
              </h6>
              <p className="mb-1 text-slate-500 dark:text-zink-200">
                {orderDetail?.shippingAddress?.addressLine1},{" "}
                {orderDetail?.shippingAddress?.addressLine2}
              </p>
              <p className="text-slate-500 dark:text-zink-200">
                {orderDetail?.shippingAddress?.landmark},
                {orderDetail?.shippingAddress?.city},
                {orderDetail?.shippingAddress?.district}
              </p>
              <p className="text-slate-500 dark:text-zink-200">
                {orderDetail?.shippingAddress?.state},
                {orderDetail?.shippingAddress?.pinCode}
              </p>
            </div>
          </div>
        </div>
        <div className="2xl:col-span-3  md:col-span-3">
          <div className="card">
            <div className="card-body">
              <div className="flex items-center justify-center size-12 bg-orange-100 rounded-md dark:bg-orange-500/20 ltr:float-right rtl:float-left">
                <CreditCard className="text-orange-500 fill-orange-200 dark:fill-orange-500/30" />
              </div>
              <h6 className="mb-4 text-15">Billing Details</h6>

              <h6 className="mb-1">
                {orderDetail?.businessDetails?.businessName}
              </h6>
              <p className="mb-1 text-slate-500 dark:text-zink-200">
                {orderDetail?.businessDetails?.addressLine1},{" "}
                {orderDetail?.businessDetails?.addressLine2}
              </p>
              <p className="text-slate-500 dark:text-zink-200">
                {orderDetail?.businessDetails?.landmark},
                {orderDetail?.businessDetails?.cityName},
                {orderDetail?.businessDetails?.districtName}
              </p>
              <p className="text-slate-500 dark:text-zink-200">
                {orderDetail?.businessDetails?.stateName},
                {orderDetail?.businessDetails?.pinCode}
              </p>
            </div>
          </div>
        </div>

        <div className="2xl:col-span-3  md:col-span-3">
          <div className="card">
            <div className="card-body">
              <div className="size-12 bg-yellow-100 rounded-md ltr:float-right rtl:float-left dark:bg-yellow-500/20">
                <img src={avatar4} alt="" className="h-12 rounded-md" />
              </div>
              <h6 className="mb-4 text-15">Customer Info</h6>

              <h6 className="mb-1">{orderDetail?.orderUser?.userName}</h6>
              <p className="mb-1 text-slate-500 dark:text-zink-200">
                {orderDetail?.orderUser?.email}
              </p>
              <p className="text-slate-500 dark:text-zink-200">
                {orderDetail?.orderUser?.phone}
              </p>
              <p className="text-slate-500 dark:text-zink-200">
                Member since : {orderDetail?.businessDetails?.memberSince}
              </p>
            </div>
          </div>
        </div>

        <div className="2xl:col-span-3  md:col-span-3">
          <div className="card">
            <div className="card-body">
              <div className="flex items-center justify-center size-12 rounded-md ltr:float-right rtl:float-left bg-sky-100 dark:bg-sky-500/20">
                <CircleDollarSign className="text-sky-500 fill-sky-200 dark:fill-sky-500/30" />
              </div>
              <h6 className="mb-4 text-15">Payment Details</h6>

              {/* <h6 className="mb-1">ID: #TSD456DF41SD5</h6> */}
              <p className="mb-1 text-slate-500 dark:text-zink-200">
                Payment Method:{" "}
                <b>{orderDetail?.orderHeader?.paymentMethod ?? "COD"}</b>
              </p>
              {/* <p className="mb-1 text-slate-500 dark:text-zink-200">Card Number: <b>xxxx xxxx xxxx 1501</b></p> */}
            </div>
          </div>
        </div>

      </div>

      <div className="grid grid-cols-1 2xl:grid-cols-12 md:grid-cols-12  gap-x-5">
        <div className="2xl:col-span-9 md:col-span-9">
          <div className="grid grid-cols-1 2xl:grid-cols-5  md:grid-cols-5 gap-x-5">
            <div>
              <div className="card">
                <div className="text-center card-body">
                  <h6 className="mb-1 underline">
                    #{orderDetail?.orderHeader?.orderNo}
                  </h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Order #
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="card">
                <div className="text-center card-body">
                  <h6 className="mb-1">
                    {format(
                      orderDetail?.orderHeader?.orderDate == null
                        ? new Date()
                        : new Date(orderDetail?.orderHeader?.orderDate),
                      "dd MMM, yyyy"
                    )}
                  </h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Order Date
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="card">
                <div className="text-center card-body">
                  <h6 className="mb-1">
                    {orderDetail?.orderHeader?.deliveryDate == null
                      ? "Not available"
                      : format(
                        new Date(orderDetail?.orderHeader?.deliveryDate),
                        "dd MMM, yyyy"
                      )}
                  </h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Delivery Date
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="card">
                <div className="text-center card-body">
                  <h6 className="mb-1">
                    ₹ {orderDetail?.orderHeader?.totalAmount}
                  </h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Order Amount
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="card">
                <div className="text-center card-body">
                  <span
                    className={`delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border 
              ${orderDetail?.orderHeader?.orderStatus === "Order Canceled" ?
                        "bg-red-100 border-red-200 text-red-500 dark:bg-red-500/20 dark:border-red-500/20" :
                        "bg-custom-100 border-custom-200 text-custom-500 dark:bg-custom-500/20 dark:border-custom-500/20"}`}
                  >
                    {orderDetail?.orderHeader?.orderStatus}
                  </span>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Order Status
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="flex items-center gap-3 mb-4" >
                <h6 className="text-15 grow">Order Summary</h6>
                {/* <a href="#!"  className="text-red-500 underline shrink-0">Cancel Order</a> */}
                <a
                  href={!isCancelable ? undefined : "#!"} // Prevent navigation
                  className={`${!isCancelable
                    ? "pointer-events-none text-gray-400 cursor-not-allowed"
                    : "text-red-500 underline shrink-0"
                    }`}
                  onClick={(e) => {
                    if (!isCancelable) {
                      e.preventDefault(); // Prevent default behavior
                    } else {
                      setCancelModal(true)
                    }
                  }}
                >
                  {"Cancle Order"}
                </a>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <tbody>
                    {orderDetail?.orderLines?.map((item: OrderLine) => (
                      <tr key={`orderline-${item.lineId}`}>
                        <td className="px-3.5 py-4 border-b border-solid first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500">
                          <div className="flex items-center gap-3">
                            {item.lineId !== null && (
                              <> 
                              <div className="flex items-center justify-center size-12 rounded-md bg-slate-100 shrink-0">
                                {item.imageUrl ? (
                                  <img src={(getImageUrl(item.imageUrl, 'productThumbnail') || '')} alt="" className="h-8" />
                                ) : (
                                  <div className="flex items-center justify-center w-8 h-8 bg-slate-200 rounded-md text-slate-400 text-xs font-medium">
                                    No Image
                                  </div>
                                )}
                              </div>
                              </>
                            )}
                            <div className="grow">
                              <h6 className="mb-1 text-15">
                                <p
                                  
                                  className="transition-all duration-300 ease-linear hover:text-custom-500"
                                >
                                  {item?.productName} 
                                </p>
                              </h6>
                              {item.lineId !== null && (
                                <>
                                  <p className="text-slate-500 dark:text-zink-200">
                                    Size : {item.size}, Set of :{item.packOf} Pcs {item?.sku ? ", SKU : " + item?.sku : ""}
                                  </p>
                                  <p className="text-slate-500 dark:text-zink-200">
                                    ₹{`(${item.unitPrice}`}{" "}
                                    {` - ${item.discountValue} ) x ${item.packOf}(Pcs) x ${item.quantity}(Qty)`}
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <div
                                      key={`$color-${100}`}
                                      style={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginRight: 10,
                                      }}
                                      className="mr-2 mb-2"
                                    >
                                      Color:
                                    </div>
                                                                         {item?.color && (
                                       <div
                                         key={`$color-${100}`}
                                         style={{
                                           width: 16,
                                           height: 16,
                                           backgroundColor: (item?.color as any) ?? '#ffffff',
                                           borderRadius: 10,
                                           justifyContent: "center",
                                           alignItems: "center",
                                           marginRight: 10,
                                         }}
                                         className="mr-2 mb-2"
                                       ></div>
                                     )}
                                  </div>
                                </>
                              )}

                            </div>
                          </div>
                        </td>
                        <td className="px-3.5 py-4 border-b border-solid first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500 ltr:text-right rtl:text-left">
                          ₹{item.totalAmount}
                          {/* {(item.unitPrice - item.discountValue) *
                            item.quantity *
                            item.packOf} */}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td className="px-3.5 pt-4 pb-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        Sub Total
                      </td>
                      <td className="px-3.5 pt-4 pb-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        ₹{orderDetail?.orderHeader?.subTotal}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        Tax (5%)
                      </td>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        ₹{orderDetail?.orderHeader?.tax}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        Item Discounts
                      </td>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        -₹{orderDetail?.orderHeader?.discountValue}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        Shipping Charge
                      </td>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        ₹{orderDetail?.orderHeader?.shippingCharges}
                      </td>
                    </tr>
                    <tr className="font-semibold">
                      <td className="px-3.5 pt-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200  border-slate-200 dark:border-zink-500 border-b border-dashed ">
                        Total Amount
                      </td>
                      <td className="px-3.5 pt-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left  border-slate-200 dark:border-zink-500 border-b border-dashed  ">
                        ₹{orderDetail?.orderHeader?.totalAmount}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="flex items-center gap-3 mb-4">
                <h6 className="text-15 grow">Update Order Status</h6>
                <div className="shrink-0">
                  <Link to="#!" className="inline-block text-custom-500 underline ltr:mr-2 rtl:ml-2" onClick={() => handleUpdateStatusClick()}>Update Status</Link>
                  {/* <Link
                    to="#"
                    className="py-1 text-xs text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    <Download className="inline-block size-4 align-middle ltr:mr-1 rtl:ml-1" />
                    <span className="align-middle">Invoice</span>
                  </Link> */}

                </div>
              </div>
              <div>
                {orderDetail?.orderStatus?.map((item: OrderStatusType, index) => (
                  <div
                    key={`order-status-${index}`}
                    className={`relative ltr:pl-6 rtl:pr-6 before:absolute ltr:before:border-l rtl:before:border-r
                      ltr:before:left-[0.1875rem] rtl:before:right-[0.1875rem] before:border-slate-200 [&.done]:before:border-slate-500 before:top-1.5 
                      before:-bottom-1.5 after:absolute after:size-2 after:bg-white after:border after:border-slate-200 after:rounded-full ltr:after:left-0 rtl:after:right-0 
                      after:top-1.5 pb-4 last:before:hidden   done ${item.statusDate ? "[&.done]:after:border-green-500 [&.done]:after:bg-green-500" : "[&.done]:after:border-slate-500 [&.done]:after:bg-slate-500"}`}
                  >
                    <div className="flex gap-4">
                      {/* <div
                        className={`absolute top-0 w-6 h-6 rounded-full transform -translate-x-1/2 ${!item.statusDate ? "bg-green-500" : "bg-orange-500"
                          }`}
                      ></div> */}
                      <div className="grow">
                        <h6 className="mb-2 text-gray-800 text-15 dark:text-zink-50">
                          {item?.statusName}
                        </h6>
                        <p className="text-gray-400 dark:text-zink-200">
                          {item?.comment}
                        </p>
                      </div>
                      <p className="text-sm text-gray-400 dark:text-zink-200 shrink-0">
                        {!item?.statusDate
                          ? ""
                          : format(
                            new Date(item?.statusDate),
                            "dd MMM yyyy, hh:mm a"
                          )}
                      </p>
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>
        <div className="2xl:col-span-3 md:col-span-3">
          <div className="card">
            <div className="card-body">
              <div className="flex items-center gap-3 mb-4">
                <h6 className="text-15 grow">Invoice</h6>
                <div style={{ textAlign: "center", marginTop: "0px" }}>
                  <Link to={invoiceUrl} target="_blank" className="inline-block text-custom-500 underline ltr:mr-2 rtl:ml-2" >Download</Link>

                </div>
              </div>
            </div>


          </div>

        </div>
      </div>

      <Modal show={show} onHide={toggle} modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[50rem] bg-white shadow rounded-md dark:bg-zink-600">
        <OrderStatus orderDetail={eventData} onSave={(result: any) => { onOrderStatusSave(result); }} onHide={toggle} />
      </Modal>
    </React.Fragment>
  );
};

export default OrderDetail;
